import { twMerge } from 'tailwind-merge';

export const PERIOD = {
  DAILY: 'daily',
  LIFETIME: 'lifetime',
};

const OPTIONS = [
  { value: PERIOD.DAILY, label: 'Daily' },
  { value: PERIOD.LIFETIME, label: 'Lifetime' },
];

export const PeriodToggle = ({ value, onChange }) => {
  return (
    <div className="flex items-center gap-1 rounded-full bg-brand-1000 p-1 shrink-0">
      {OPTIONS.map(({ value: optionValue, label }) => {
        const isActive = optionValue === value;

        return (
          <button
            key={optionValue}
            type="button"
            onClick={() => onChange(optionValue)}
            className={twMerge(
              'rounded-full py-2 px-5 font-medium text-[16px]/[24px] focus-visible:outline-none',
              isActive ? 'bg-white text-brand-1000' : 'text-white',
            )}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};
